const MainTitle = ({ title, className = 'text-text-primary', animation }) => {
  return (
    <h1
      className={`font-serif text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-bold leading-tight
        drop-shadow-lg
        ${className}`}
      data-aos={animation}>
      {title}
    </h1>
  );
};

export default MainTitle;
